export default __webpack_public_path__ + "static/media/fj.439cb569.svg";